// ECRIT A LA MAIN, icone du fondateur (voir `./index.ts`).
import { createCustomIcon } from './create-custom-icon.js';

/**
 * Ajouter un fichier : un dossier, avec un plus en bas a droite. Source
 * `icone-ajouter-fichier.webp`.
 *
 * Fournie par le fondateur, REDESSINEE ici en cadre `0 0 24 24` et au poids
 * du dossier `IconNewFolder` (contour plein de 2.5 unites, de 0.75 a 3.25),
 * pour tenir a cote des autres icones d'action. Le coin bas droit du dossier
 * est OUVERT (le cote droit s'arrete a y = 10, le bas a x = 10.5) : c'est la
 * place du plus, centre en (18, 18), dont les bras vont de 12.75 a 23.25.
 */
export const IconAjouterFichier = createCustomIcon(
  'IconAjouterFichier',
  '0 0 24 24',
  <>
    <path
      fill="currentColor"
      d="M.75 23.25V.75h7.768l3 3H23.25V10h-2.5V6.25H10.482l-3-3H3.25v17.5h7.25v2.5z"
    />
    <path
      fill="currentColor"
      d="M16.75 12.75h2.5v4h4v2.5h-4v4h-2.5v-4h-4v-2.5h4z"
    />
  </>,
);
